import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=32bcd5b6&scoped=true"
import script from "./Share.vue?vue&type=script&lang=ts"
export * from "./Share.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bcd5b6",
  null
  
)

export default component.exports